import { useState } from 'react';
import { cx, Modal, UsdtIcon } from './ui';

/**
 * "USDT ⓘ" chip shown next to balances. Opens a short plain-language explanation of USDT, the
 * account currency: what it is, that amounts are shown with $ because 1 USDT tracks $1, and how
 * money goes in and out.
 */
export function UsdtChip({ className }: { className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-label="What is USDT?"
        title="What is USDT?"
        className={cx('inline-flex h-[22px] items-center gap-1 rounded-full border border-line-strong py-0 pr-2 pl-1 text-[11.5px] font-semibold text-fg hover:bg-raised', className)}
      >
        <UsdtIcon size={15} />
        USDT
        <span aria-hidden="true" className="font-medium text-muted">
          ⓘ
        </span>
      </button>
      <UsdtExplainer open={open} onClose={() => setOpen(false)} />
    </>
  );
}

const FACTS: [string, string][] = [
  ['Prices', 'Shown with $ because 1 USDT tracks $1.'],
  ['Deposit', 'Send USDT on TRON (TRC20), Ethereum (ERC20) or BNB Chain (BEP20), or pay by card or bank. We credit 1 USDT for every $1.'],
  ['Withdraw', 'In USDT to your crypto address, or to your bank or card in USD, EUR or GBP.'],
  ['Good to know', 'USDT is issued by a private company, and its value can move slightly away from $1.'],
];

export function UsdtExplainer({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} onClose={onClose} title="What is USDT?" width={420}>
      <p className="m-0 text-[14px] leading-relaxed">
        USDT (Tether) is a stablecoin: a digital currency built to stay worth 1 US dollar. Your balance, margin and profit or loss are all in USDT.
      </p>
      <div className="num rounded-lg bg-raised px-3 py-2 text-center text-[14px]">1,000 USDT ≈ $1,000</div>
      <dl className="m-0 grid grid-cols-[auto_minmax(0,1fr)] gap-x-3 gap-y-2 text-[13.5px]">
        {FACTS.map(([k, v]) => (
          <div key={k} className="contents">
            <dt className="text-muted">{k}</dt>
            <dd className="m-0">{v}</dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
